import { render, staticRenderFns } from "./ProfileSpecialistCategories.vue?vue&type=template&id=69047484"
import script from "./ProfileSpecialistCategories.vue?vue&type=script&lang=js"
export * from "./ProfileSpecialistCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports